import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function Input({
  id,
  label,
  name,
  className,
  wrapperClassName,
  helperText,
  ...props
}) {
  return (
    <div className={twMerge('flex flex-col gap-1', wrapperClassName)}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-900">
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        className={twMerge(
          'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm',
          'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100',
          className,
        )}
        {...props}
      />
      {helperText && (
        <p id={`${id}-description`} className="text-gray-500">
          {helperText}
        </p>
      )}
    </div>
  );
}
